<script setup>
import { cn } from 'dashboard/lib/utils';

const props = defineProps({
  class: { type: String, default: '' },
});
</script>

<template>
  <tr
    :class="
      cn(
        'border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted',
        props.class
      )
    "
  >
    <slot />
  </tr>
</template>
